


@for (room of rooms; track $index) {
    <div class="payment-summary-room-row">
        <div class="payment-summary-row">
            <div class="col" [attr.data-testid]="'booking-summary'">

                {{room.item.room.pim?.name  ?? room.item.room.roomName}}, {{daysDelta}} @if (daysDelta == 1) { {{"pr.night"|translate}} } @else { {{"pr.nights"|translate}} } ( {{room.searchParams.arrival | date}} - {{room.searchParams.departure | date}} )
                <div class="payment-summary-cancellation-policy" [innerHTML]="room.item.rate.pim?.cancellationPolicy"></div>

            </div>
            <div class="col-3 price-col">
                <div class="payment-summary-price" [attr.data-testid]="'booking-summary-room-price'">{{room.item.totalPriceForStayWithTaxes|currency}}</div>
            </div>
        </div>

        @for (extra of room.extras; track $index) {
            <div class="payment-summary-extra-row">
                <div class="col">
                    {{extra.quantity}} x {{ extra.pim?.name ??  extra.extraName |stripTags }}
                    <p-button icon=""  [rounded]="true" [text]="true" class="edit-extra-button" (click)="editExtra(extra)" [attr.data-testid]="'booking-summary-edit-extra'">
                        <span class="material-symbols-outlined">
                            edit_square
                        </span>
                    </p-button>

                </div>
                <div class="col-3 price-col">
                    <div class="payment-summary-price" [attr.data-testid]="'booking-summary-extra-price'">{{(extra.quantity * extra.totalPriceForStayWithTaxes)|currency}}</div>
                </div>
            </div>

        }
    </div>
}

<div class="payment-total-row">
    <div class="col">
        <div>{{"pr.Total"|translate}}</div>
        <div class="payment-summary-price" [attr.data-testid]="'booking-summary-total-price'">{{shopCart.getTotalPrice()|currency}}</div>
    </div>
</div>

<app-edit-extra-dialog [extrasToEdit]="extrasToEdit" (onClose)="hideEditExtraDialog()" (onChangeQuantity)="updateEditExtraQuantity($event.event, $event.index)" [testId]="'extra-dialog-edit'"></app-edit-extra-dialog>
